const capitalize = (s: string): string => (s && s[0].toUpperCase() + s.slice(1)) || "";

export const capitalizeEachWord = (s: string) => {
    return s.replaceAll(/((^\w)|(\s|-)\w)/g, (v) => v.toUpperCase());
}

export default capitalize